import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import ArrowIcon from 'dibs-vg/dist/react/arrow-right';
import styles from './PdpSharedNotListedHeader.scss';

// min number of items to link creator on suspended art Pdp
const MIN_ITEM_COUNT = 2;

function PdpSharedNotListedHeaderComponent({ item, additionalStyles }) {
    const { vertical } = item;
    const itemTitle = get(item, 'title');

    // artCreator
    const { displayName, name, urlTag, publishedItemsCount } =
        get(item, 'creators[0].creator') || {};
    const creatorName = displayName || name;
    const creationDate = get(item, 'classification.creationDate');

    // browse link section
    const categoryName =
        get(item, 'categorNameLevel3[0].name') || get(item, 'categorNameLevel2[0].name');
    const count = get(item, 'categoryPathItemCount');
    const url = get(item, 'browseUrl');
    const browseLinkText = (
        <FormattedMessage
            id="PdpSharedNotListedHeader.browse_link"
            defaultMessage="Browse {count, number} other {categoryName}"
            values={{
                count,
                categoryName,
            }}
        />
    );

    const headerClass = classnames(styles.header, {
        [additionalStyles.header]: !!additionalStyles,
    });
    const titleClass = classnames(styles.title, {
        [additionalStyles.title]: !!additionalStyles,
    });

    let artCreator = creatorName;

    if (urlTag && publishedItemsCount >= MIN_ITEM_COUNT) {
        artCreator = (
            <a href={`/creators/${urlTag}/${vertical}/`} title={creatorName}>
                {creatorName}
            </a>
        );
    }

    return (
        <div className={headerClass}>
            <div className={titleClass} data-tn="pdp-shared-not-listed-message">
                <FormattedMessage
                    id="PdpSharedNotListedHeader.title"
                    defaultMessage="Sorry, {creatorName} {title} {creationDate} is not currently available."
                    values={{
                        title: <span className={styles.text}>{itemTitle}</span>,
                        creatorName: item.isArt && artCreator,
                        creationDate: item.isArt && creationDate,
                    }}
                />
            </div>
            <div className={styles.browseLink} data-tn="pdp-shared-not-listed-header">
                <a href={url} data-tn="pdp-shared-not-listed-header-a-tag">
                    {browseLinkText}
                    <ArrowIcon className={styles.arrowIcon} />
                </a>
            </div>
        </div>
    );
}

PdpSharedNotListedHeaderComponent.defaultProps = {
    additionalStyles: {},
};

PdpSharedNotListedHeaderComponent.propTypes = {
    item: PropTypes.object.isRequired,
    additionalStyles: PropTypes.object,
};

export const PdpSharedNotListedHeader = createFragmentContainer(PdpSharedNotListedHeaderComponent, {
    item: graphql`
        fragment PdpSharedNotListedHeader_item on Item {
            isArt
            title
            browseUrl
            categoryPathItemCount
            creators {
                creator {
                    name
                    displayName
                    urlTag
                    publishedItemsCount
                }
            }
            classification {
                creationDate
            }
            categorNameLevel3: getCategoriesByLevel(level: 3) {
                name
            }
            categorNameLevel2: getCategoriesByLevel(level: 2) {
                name
            }
            vertical
        }
    `,
});
